import { defineMessages } from "react-intl";

export default defineMessages({
  reached: {
    id: "superTalent.reached",
    defaultMessage: "Atteint",
  },
  notReached: {
    id: "superTalent.notReached",
    defaultMessage: "Pas atteint",
  },
  seeMore: {
    id: "superTalent.seeMore",
    defaultMessage: "Voir plus <RightIcon></RightIcon>",
  },
  average_rating: {
    id: "superTalent.averageRating",
    defaultMessage: "Evalutation clients :",
  },
  jobs_closed: {
    id: "superTalent.jobsClosed",
    defaultMessage: "Jobs clôturés :",
  },
  repeat_rate: {
    id: "superTalent.repeatRate",
    defaultMessage: "Clients récurrents :",
  },
  realisation_rate: {
    id: "superTalent.realisationRate",
    defaultMessage: "Taux de réalisation :",
  },
  verified: {
    id: "superTalent.verified",
    defaultMessage: "Badge vérifié",
  },
  respects_rules: {
    id: "superTalent.respectsRules",
    defaultMessage: "Charte Ring Twice : Respectée",
  },
  average_rating_threshold: {
    id: "superTalent.averageRatingThreshold",
    defaultMessage: "min {threshold}/5",
  },
  jobs_closed_threshold: {
    id: "superTalent.jobsClosedThreshold",
    defaultMessage: "min {threshold}",
  },
  repeat_rate_threshold: {
    id: "superTalent.repeatRateThreshold",
    defaultMessage: "min {threshold}%",
  },
  realisation_rate_threshold: {
    id: "superTalent.realisationRateThreshold",
    defaultMessage: "min {threshold}%",
  },
  discoverAdvantages: {
    id: "superTalent.discoverAdvantages",
    defaultMessage:
      "Découvrir les avantages exclusifs du <whiteBold></whiteBold>",
  },
  youAreSuperTalentInfos: {
    id: "superTalent.youAreSuperTalentInfos",
    defaultMessage:
      "Bravo, <whiteBold></whiteBold> Découvrez vos avantages exclusifs",
  },
  youAreSuperTalent: {
    id: "superTalent.youAreSuperTalent",
    defaultMessage: "vous êtes actuellement SuperTalent !",
  },
  superTalentName: {
    id: "superTalent.superTalentName",
    defaultMessage: "SuperTalent",
  },
  discover: {
    id: "superTalent.discover",
    defaultMessage: "En savoir plus",
  },
  superTalent: {
    id: "superTalent.superTalent",
    defaultMessage: "<superTalentBadge></superTalentBadge>Super talent",
  },
  topProviderMessage: {
    id: "superTalent.topProviderMessage",
    defaultMessage:
      "Faites partie des <bold>prestataires les plus fiables</bold> et bénéficiez d’une meilleure visibilité.",
  },
  super_talent_advantage_one_title: {
    id: "superTalent.superTalentAdvantageOneTitle",
    defaultMessage: "Recevez les jobs en priorité",
  },
  super_talent_advantage_one_subtitle: {
    id: "superTalent.superTalentAdvantageOneSubtitle",
    defaultMessage: "Soyez les premiers au courant des nouveaux jobs.",
  },
  super_talent_advantage_two_title: {
    id: "superTalent.superTalentAdvantageTwoTitle",
    defaultMessage: "Badge SuperTalent",
  },
  super_talent_advantage_two_subtitle: {
    id: "superTalent.superTalentAdvantageTwoSubtitle",
    defaultMessage:
      "Gagnez en reconnaissance. Les clients voient qui sont les prestataires les plus fiables.",
  },
  super_talent_advantage_three_title: {
    id: "superTalent.superTalentAdvantageThreeTitle",
    defaultMessage: "Faites autant de jobs que vous voulez",
  },
  super_talent_advantage_three_subtitle: {
    id: "superTalent.superTalentAdvantageThreeSubtitle",
    defaultMessage: "Plus de limite sur le nombre de jobs en cours.",
  },
  yourScoreWithDots: {
    id: "superTalent.yourScoreWithDots",
    defaultMessage: "Votre score : ",
  },
  value_average_rating: {
    id: "superTalent.valueAverageRating",
    defaultMessage: "{value}/5",
  },
  value_jobs_closed: {
    id: "superTalent.valueJobsClosed",
    defaultMessage: "{value}",
  },
  value_realisation_rate: {
    id: "superTalent.valueRealisationRate",
    defaultMessage: "{value} %",
  },
  value_repeat_rate: {
    id: "superTalent.valueRepeatRate",
    defaultMessage: "{value} %",
  },
  value_respects_rules: {
    id: "superTalent.valueRespectsRules",
    defaultMessage: "En règle",
  },
  value_verified: {
    id: "superTalent.valueRespectsRules",
    defaultMessage: "En règle",
  },
  value_respects_rules_not_reached: {
    id: "superTalent.valueRespectsRulesNotReached",
    defaultMessage: "Pas respectée",
  },
  value_verified_not_reached: {
    id: "superTalent.notReached",
    defaultMessage: "Pas atteint",
  },
  no_information: {
    id: "superTalent.noInformation",
    defaultMessage: "-",
  },
  to_be_defined: {
    id: "superTalent.toBeDefined",
    defaultMessage: "A définir",
  },
});
